import { AUTH_API_URL } from '../api/config';
import ENDPOINTS from '../api/endpoints';

export const getAppDomain = (): string => {
  const url = window.location.href;
  const { hostname } = new URL(url);

  // Detect local development environments
  const isLocalhost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname);

  if (isLocalhost) {
    return 'templatev2'; // Default for all local environments
  }

  if (url.includes('ctbiryani')) {
    return 'ctbiryani';
  }

  const domainParts = hostname.split('.');
  if (domainParts.length > 2) {
    if (domainParts.indexOf('www') === -1) {
      return domainParts.slice(0, -2).join('.');
    } else {
      return domainParts[1];
    }
  }

  // Fallback: Use the hostname without TLD
  return domainParts[0];
};

export const buildUrlWithDomain = (path: string): string => {
  const domain = getAppDomain();
  return `${AUTH_API_URL}${path}?domain=${domain}`;
};

export const buildRestaurantUrl = (): string => {
  const domain = getAppDomain();
  return `${AUTH_API_URL}${ENDPOINTS.RESTAURANT_DETAILS_API_PATH}?domain=${domain}`;
};
